import { computed, Injectable, signal } from '@angular/core';

interface AlertOptions extends Options {
  message: string;
}

interface Options {
  hideClose?: boolean;
  time?: number;
  actionLabel?: string;
  type?: 'success' | 'warning' | 'error' | 'information';
  action?: () => void;
}

const defaultOptions: Options = {
  hideClose: false,
  time: 10000,
  actionLabel: '',
  type: 'error',
};

@Injectable({ providedIn: 'root' })
export class AlertService {
  private openAlert = signal<boolean>(false);
  alertOptions = signal<AlertOptions>({ message: '' });
  timer?: ReturnType<typeof setTimeout>;
  isAlertOpen = computed<boolean>(this.openAlert);

  open(message: string, options: Options = {}) {
    if (this.openAlert()) {
      this.closeAlert();

      setTimeout(() => {
        this.alertOptions.set({ ...defaultOptions, ...options, message });
        this.start();
      }, 200);
    } else {
      this.alertOptions.set({ ...defaultOptions, ...options, message });
      this.start();
    }
  }

  start() {
    this.openAlert.set(true);

    this.timer = setTimeout(() => {
      this.closeAlert();
    }, this.alertOptions().time);
  }

  closeAlert() {
    this.openAlert.set(false);
    clearTimeout(this.timer);
  }
}
